import React, {useState, useEffect, useRef} from 'react';
import AlgorithmsDetails from '../AlgorithmsDetails/AlgorithmsDetails';
import AlgoritmsScreenDetailsEnd from "../oldAlgorithmsDetails/alogrithmsDetails";
import styles from './App.module.css';

function App() {

    const [data, setData] = useState([]);
    const algorithmsDetails = useRef();

    useEffect(() => {
        (async function fetchData() {

            const id = window.webalgo_json;

            if(id) {
                const res = await fetch(`https://karat-expert.ru/wp-json/webalgos/getalgo?password=wildgeese&id=${id}`)
                .then(res => res.json());
                setData(JSON.parse(res.data))
            } else {
                setData([]);
            }
            algorithmsDetails.current && algorithmsDetails.current.refresh();
        })()
    }, []);

    return (
        <div className={styles.wrap}>
            {(data[0] !== undefined && (data[0].result !== undefined || data[0].answers !== undefined)) === true ?
                <AlgoritmsScreenDetailsEnd/>
                :
                <AlgorithmsDetails ref={algorithmsDetails} data={data}/>}
        </div>
    );
}

export default App;
